<template>
    <div>
        <div class="main">
			<div v-if="label==0">
				<img src="../static/state/z01.png" alt="">
				{{$t('m.zw_txt1')}}
			</div>
			<div v-if="label==1">
				<img src="../static/state/z02.png" alt="">
				{{$t('m.zw_txt2')}}
			</div>
			<div v-if="label==2">
				<img src="../static/state/z03.png" alt="">
				{{$t('m.zw_txt3')}}
			</div>
			<div v-if="label==3">
				<img src="../static/state/z04.png" alt="">
				{{$t('m.zw_txt4')}}
			</div>
            
<!--            <img v-if="label==1" src="../static/state/z02.png" alt="">
            <img v-if="label==2" src="../static/state/z03.png" alt="">
            <img v-if="label==3" src="../static/state/z04.png" alt=""> -->
        </div>

    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {

        }

    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.main {
    padding: 150px 0;
    display: flex;
    align-items: center;
    justify-content: center;
	div{
		text-align: center;
		img{display: block;margin: auto;}
	}
}
</style>